import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=34e36bf2"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=34e36bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports